module.exports = __webpack_public_path__ + "static/img/sdk.f833e6eb.png";